import { useContext, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { toggleScroll } from 'utils/use';
import Context from 'root/Context';
import { section_links } from 'root/data/section_links';
import LinkIcon from 'components/LinkIcon/LinkIcon';
import './Menu.scss';
import Icon from 'ui/Icon/Icon';
import ListIcon from 'ui/SVG/ListIcon';
import { ControllerContext } from 'components/Controller/Controller';

const Menu: React.FC = () => {
  const { isMenu, toggleMenu } = useContext(Context);
  const { active, dispatchActive } = useContext(ControllerContext)

  const onResize = () => {
    toggleScroll(window.innerWidth > 912 ? true : !isMenu);
  };

  useEffect(() => {
    toggleScroll(!isMenu);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [isMenu]);

  return (
    <CSSTransition
      classNames="menu"
      timeout={700}
      in={isMenu}
      mountOnEnter
      unmountOnExit
    >
      <div className="menu" id="menu">
        <div className="menu__content">
          <ul className="menu__list">
            {Object.entries(section_links).map(([name, _]) => (
              <li className="menu__item" key={name}>
                <button 
                onClick={() => { dispatchActive(name); toggleMenu(false) }} 
                className="menu__item-btn">
                  <LinkIcon className="menu__item-icon">
                    <img src={_[0]} alt="icon" />
                  </LinkIcon>
                  <p className="menu__item-name">
                    Galaxy "<span>{_[1]}</span>"
                  </p>
                </button>
              </li>
            ))}
          </ul>
          <button className="whitelist-btn menu__btn">
            <Icon className="whitelist-btn__icon">
              <ListIcon />
            </Icon>
            <p className="whitelist-btn__text">Go to App</p>
          </button>
        </div>
      </div>
    </CSSTransition>
  );
};

export default Menu;
